import React, { useContext, useState } from 'react'
import { ContextoGlobal, ContextoGlobalInterface } from '../../GlobalStates/ContextoGlobal'
import BackEndAPI from '../../Services/BackEndAPI'
import { Box, Button, Grid, Paper, Stack, Typography } from '@mui/material'
import InputText from '../../DevComponents/InputText'
import { MensagemTipo } from '../../GlobalStates/MensagemState'
import { EMDESENVOLVIMENTO, VERSAO_SISTEMA } from '../../ImportBackend/Config/emDesenvolvimento'
import ClsUtils from 'zlib-utils'
import { RedefinirSenhaInterface } from '../../ImportBackend/Interfaces/LoginInterfaces'
import { RespostaPadraoInterface } from '../../ImportBackend/Interfaces/PadraoInterfaces'

export default function EsqueciSenha () {

  const contextoGlobal = useContext( ContextoGlobal ) as ContextoGlobalInterface

  const { mensagemState, setMensagemState } = ( useContext( ContextoGlobal ) as ContextoGlobalInterface )
  const { loginState, setLoginState } = ( useContext( ContextoGlobal ) as ContextoGlobalInterface )

  const ResetDados: RedefinirSenhaInterface = {
    login: '',
    email: ''
  }

  const [dados, setDados] = useState<RedefinirSenhaInterface>( ResetDados )

  const clsApi = new BackEndAPI()

  const enviarNovaSenha = () => {

    const mutation: string = `
      esqueciSenha(dados: ${( new ClsUtils() ).ConverterEmGql( dados )} ) {
        ok
        mensagem
      }
    `

    clsApi.mutation<RespostaPadraoInterface>( mutation, 'esqueciSenha', 'Enviando Senha...', contextoGlobal ).then( rs => {

      if ( rs.ok ) {

        setLoginState( { ...loginState, esqueceuSenha: false, logado: false, obrigatorioAlterarSenha: false } )


      } else {
        setMensagemState( {
          ...mensagemState,
          exibir: true,
          mensagem: 'Erro ao Enviar Nova Senha!',
          tipo: MensagemTipo.Error,
          exibirBotao: true
        } )
      }

    } )

  }

  return (
    <>
      <Grid
        container
        justifyContent='center'
        alignItems='center'
        height='100vh'
      >
        <Grid item xs={10} sm={8} md={6} lg={4}>
          <Paper>
            <Box
              sx={{ backgroundColor: 'primary.main', padding: 2 }}
              textAlign='center'
            >
              <img src={process.env.REACT_APP_PASTA?.concat( "/logobranca.png" )} width={100} alt={process.env.REACT_APP_TITULO} />
              <Typography component="p" variant="h6" color="white">
                Versão
                <Typography component="span" variant="body1" color="white">
                  &nbsp;{VERSAO_SISTEMA}&nbsp;
                  <Typography component="span" variant="h6" color="white">
                    {EMDESENVOLVIMENTO ? 'VERSÃO DESENVOLVIMENTO!!!' : ''}
                  </Typography>
                </Typography>
              </Typography>
            </Box>
            <Box
              sx={{ backgroundColor: 'white', padding: 2, mx: 5 }}

            >
              <Grid>
                <Grid item textAlign='center'>
                  <Typography variant="h4" fontFamily='sans-serif' fontWeight='bolder' color="primary.main">
                    Redefinir Senha
                  </Typography>
                </Grid>

                <Grid item>
                  <InputText
                    dados={dados}
                    field='login'
                    label='Usuário'
                    setState={setDados}
                  />
                </Grid>

                <Grid item>
                  <InputText
                    dados={dados}
                    field='email'
                    label='e-mail'
                    setState={setDados}
                  />
                </Grid>

                <Grid item sx={{ mt: 2 }}>
                  <Stack direction='row' spacing={5} justifyContent='space-between' alignItems='center'>
                    <Typography variant="body2" color="primary.main" sx={{ cursor: 'pointer' }} onClick={() => setLoginState( { ...loginState, esqueceuSenha: false, logado: false, obrigatorioAlterarSenha: false } )}>Entrar</Typography>
                    <Button variant='contained' onClick={() => enviarNovaSenha()}>Enviar Nova Senha</Button>
                  </Stack>
                </Grid>

              </Grid>

            </Box>
          </Paper>
        </Grid>
      </Grid>
    </>
  )

}